import dayjs from 'dayjs';
import { MyTimeOffType} from '../../pages/profile/MyTimeOff';
import { TimeOutLogCardData } from '../../pages/profile/TimeOffBalancesCard';
import { ApiMessage, ApiResponseHandler } from '../ApiResponseHandler';
import ThomApiClient from '../ThomApiClient';
import TbbApiClient from '../TbbApiClient';

export interface TimeOffData {
  id?: string;
  typeId: string;
  noOfHrs: string | null;
  totalDays: string | null;
  totalHours: string | null;
  durationType: string;
  effectiveStartDate: string | null;
  effectiveEndDate: string | null;
  startTime: string | null;
  reason: string;
  leaveName: string;
}

export interface TimeOffHistory {
  id: string;
  typeId: string;
  startDate: string | null;
  effectiveStartDate?: string | null;
  effectiveEndDate?: string | null;
  endDate: string | null;
  modifiedDate: string;
  modifiedBy: string;
  leaveName: string;
  noOfHrs: string | null;
  totalDays: string | null;
  isDeleted: boolean;
  isCreatedByRS: boolean;
}

export interface TimeOffHistoryResponse {
  latestTimeOff: TimeOffHistory;
  timeOffHistory: TimeOffHistory[];
}
// Calls the separate TBB service (based off REACT_APP_TBB_API, see Constant.ts)
// Returns TimeOutLogCardData[] (name/totalAccrualBenifit/accruedYtd/
// usedYtd/pendingHours/balanceAvailable/remainderToAccrue) to power the time-off balance cards.
export const getEmployeeTimeOffBalances = async (
  programId: string,
  employeeId: string,
  startDate: string,
  endDate: string,
): Promise<TimeOutLogCardData[]> => {
  return ApiResponseHandler(
    await TbbApiClient.getInstance().get<TimeOutLogCardData[]>(
      `dashboard/employee/timeoff-cards/summary?programId=${programId}&employeeId=${employeeId}&startDate=${encodeURIComponent(
        startDate,
      )}&endDate=${encodeURIComponent(endDate)}`,
    ),
  );
};

export const addEmployeeMyTimeOff = async (
  employeeId: string,
  requestBody: TimeOffData,
  fiscalStartTime: string,
  fiscalEndTime: string,
): Promise<TimeOffData> => {
  const timezone = encodeURIComponent(dayjs(new Date()).format('Z'));
  return ApiResponseHandler(
    await ThomApiClient.getInstance().post(
      `employee/timeOff?employeeId=${employeeId}&timezone=${timezone}&fiscalStartTime=${fiscalStartTime}&fiscalEndTime=${fiscalEndTime}`,
      requestBody,
    ),
  );
};

export const getEmployeeMyTimeOff = async (
  employeeId: string,
  pageNo: number,
  fiscalStartTime: string,
  fiscalEndTime: string,
  order: string,
  orderBy: string,
  pageSize: number,
  status: string,
): Promise<MyTimeOffType> => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get(
      `employee/timeOff?employeeId=${employeeId}&page=${pageNo}&size=${pageSize}&sort=${orderBy}&sortType=${order.toUpperCase()}&fiscalStartDate=${fiscalStartTime}&fiscalEndDate=${fiscalEndTime}&isAvailableHrs=true&status=${status}`,
    ),
  );
};

export const updateEmployeeMyTimeOff = async (
  employeeId: string,
  requestBody: TimeOffData,
  fiscalStartTime: string,
  fiscalEndTime: string,
): Promise<ApiMessage> => {
  const timezone = encodeURIComponent(dayjs(new Date()).format('Z'));
  return ApiResponseHandler(
    await ThomApiClient.getInstance().put(
      `employee/timeOff?employeeId=${employeeId}&timezone=${timezone}&fiscalStartTime=${fiscalStartTime}&fiscalEndTime=${fiscalEndTime}`,
      requestBody,
    ),
  );
};

export const deleteEmployeeMyTimeOff = async (
  timeOffId: string,
): Promise<ApiMessage> => {
  const timezone = encodeURIComponent(dayjs(new Date()).format('Z'));
  return ApiResponseHandler(
    await ThomApiClient.getInstance().delete(
      `employee/timeOff/${timeOffId}?timezone=${timezone}`,
    ),
  );
};

export const getHoursOutHistory = async (employeeId: string, date: string) => {
  return ApiResponseHandler(
    await ThomApiClient.getInstance().get<TimeOffHistoryResponse[]>(
      `timeOff/history?employeeId=${employeeId}&date=${date}`,
    ),
  );
};
